import { useTranslation } from 'react-i18next'

import { Link } from 'react-router-dom'

import { useAppSettings } from '@/stores/useAppSettings'

import { paths } from '@/config/paths'

export function AppFooterLinks() {
  const { t } = useTranslation(['common'])
  const { getSetting } = useAppSettings()

  const supportUrl = getSetting('general.support_url') || ''
  const termsUrl = getSetting('general.terms_url') || paths.public.legal.terms.getHref()
  const privacyUrl = getSetting('general.privacy_url') || paths.public.legal.privacyPolicy.getHref()

  return (
    <div className='text-muted-foreground max-w-xs px-4 text-center text-xs'>
      <nav className='[&_a:hover]:text-primary inline-flex space-x-4 transition-all [&_a:hover]:underline [&_a:hover]:underline-offset-4'>
        <Link to={supportUrl} target='_blank' rel='noopener noreferrer'>
          {t('common:authLayout.links.help', 'Help')}
        </Link>
        <Link to={termsUrl} target='_blank' rel='noopener noreferrer'>
          {t('common:authLayout.links.terms', 'Terms of Service')}
        </Link>
        <Link to={privacyUrl} target='_blank' rel='noopener noreferrer'>
          {t('common:authLayout.links.policy', 'Privacy Policy')}
        </Link>
      </nav>
    </div>
  )
}
